import behavior from '@/ai/components/mixins/card-behavior'
import grid from './card-grid-behavior'
import AiManualDevice from '../AiManualDevice.vue'
export default { ...grid, mixins: [behavior], components: { AiManualDevice } }
